import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import DragAndDropUploader from "./ImageUploader";
import ImageUploadSection from "./ImageUploader";
import FormBrand from "./FormBrand";
import Link from "@mui/material/Link";
import BrandTable from "./BrandTable";
import { craetebrandsonly, getbrandetails } from "./api";
import { getToken } from "../../utils/utils";

import { useLocation, useNavigate } from "react-router-dom";
import Boximageuploader from "./Boximageuploader";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import Imageuploadbrand from "./Imageuploadbrand";
interface BrandDetails {
  id: any; // Replace `any` with the actual type if known
  requestedOn: string;
  brandName: any;
  availableLocations: any;
  tenPackMRP: any;
  twentyPackMRP: any;
  brandImage: any;
  status: any;
}

export default function AddBrand() {
  const token = getToken();
  const [topPanel, setTopPanel] = useState<string>("");
  const [keyVisual, setKeyVisual] = useState<string>("");

  const [brandName, setBrandName] = useState("");
  const [availableLocation, setAvailableLocation] = useState<string[]>([]);

  const [branddetails, setbranddetails] = useState<any[]>([]);

  const [branddetails22, setbranddetails22] = useState<any[]>([]);
  const [branddetails1, setbranddetails1] = useState<BrandDetails | null>(null);
  const [packDetails, setPackDetails] = useState({
    "10's Pack MRP Amount": "",
    "20's Pack MRP Amount": "",
  });
  const [formData, setFormData] = useState({
    brandName: "",
    availableLocation: "",
    packDetails: {
      "10's Pack MRP Amount": "",
      "20's Pack MRP Amount": "",
    },
    imageData: null,
  });

  const location = useLocation();
  const { showAlert } = useAlert();
  //const [imagedataValue, setimageDataValue] = useState<string[]>([]);
  const navigate = useNavigate();
  const [imagedataValue, setimageDataValue] = useState<string>("");
  const [imagedataValuekeyimage, setimageDataValuekeyimage] =
    useState<string>("");

  // useEffect(() => {
  //     if (location.state?.valuetabsdatapage) {
  //       console.log(location.state?.valuetabsdatapage, "location.state?.valuetabsdatapage" )
  //       settotalcount12(location.state.valuetabsdatapage);
  //     }
  //   }, [location.state]);
  useEffect(() => {
    if (location.state?.selectedkeyVisual23) {
      console.log(
        location.state?.selectedkeyVisual23,
        "location.state?.imageDatalocation.state?.imageDatabrand666"
      );
      setimageDataValuekeyimage(location.state.selectedkeyVisual23);
    }
  }, [location.state]);

  console.log(imagedataValue, "imagedataValueimagedataValue");
  console.log(imagedataValuekeyimage, "imagedataValuekeyimageeeeeeeee");
  const [uploadedImage, setuploadedImage] = useState();


  useEffect(() => {
    console.log("Received state in /add-brand:", location.state);

    if (location.state?.selectedtopPanel23) {
      setimageDataValue(location.state.selectedtopPanel23);
    }


  }, [location.state]);
  const handleAddBrand = async () => {

    if (!token) {
      console.error("Token is missing!");

      return;
    }

    console.log(
      "Type of imagedataValuekeyimage:",
      typeof imagedataValuekeyimage
    );

    const reqBody = {
      brand_name: brandName,
      type: "brands",

      image_path:
        keyVisual
          ? keyVisual.split(",").join(",")
          : "",

      large_brand_image: topPanel ? topPanel : "",
      brand_availbale_locations: availableLocation,
      ten_pack_MRP_amount: packDetails["10's Pack MRP Amount"],
      twenty_pack_MRP_amount: packDetails["20's Pack MRP Amount"],
      status: "PENDING_APPROVAL",
    };

    try {
      const response = await craetebrandsonly(reqBody, token);
console.log(response, "dfsdfdfdfdfdfdf")
      console.log("Brand added successfully:", response.data);



      const mappedTask = response.data.data.map((item: {
        large_brand_image: any; id: any; created_at: string | number | Date; brand_name: any; brand_availbale_locations: any; ten_pack_MRP_amount: any; twenty_pack_MRP_amount: any; image_path: any; status: any;
      }) => ({
        id: item.id,
        requestedOn: new Date(item.created_at).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
        brandName: item.brand_name,
        availableLocations: item.brand_availbale_locations,
        tenPackMRP: item.ten_pack_MRP_amount,
        twentyPackMRP: item.twenty_pack_MRP_amount,
        brandImage: [item.image_path, item.large_brand_image].filter(Boolean).join(", "),
        status: item.status,
      }));

      setbranddetails1(mappedTask);

      showAlert("Brand create successfully!", "success");
       navigate(`/brands`);
      setTimeout(() => window.location.reload(), 100);
    
    }catch (error: any) {
  console.error("Error adding brand:", error);

  const errorMessage =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    "An error occurred while adding the brand.";

  showAlert(errorMessage, "error");
}}



  console.log(branddetails1, "branddetailsbranddetailsbranddetails33333")

  // Custom Error for brands strts//
  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    const isBrandValid = brandName.trim() !== "";
    const isLocationValid = availableLocation.length > 0;
    const is10sValid =
      packDetails["10's Pack MRP Amount"].trim() !== "" &&
      !isNaN(Number(packDetails["10's Pack MRP Amount"]));
    const is20sValid =
      packDetails["20's Pack MRP Amount"].trim() !== "" &&
      !isNaN(Number(packDetails["20's Pack MRP Amount"]));

    setIsFormValid(isBrandValid && isLocationValid && is10sValid && is20sValid);
  }, [brandName, availableLocation, packDetails]);

  // Custom Error for brands ends//
  console.log(topPanel, "topPaneleeeeeeeeeeeeee")
  console.log(keyVisual, "keyVisualffffffffffff")
  return (
    <div>
      <Box sx={{ padding: "28px 32px 0" }}>
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ display: "flex", fontSize: "14px" }}>
            <Link href="/brands" sx={{ fontSize: "14px", color: "#696A6B", paddingRight: "4px", textDecoration: "none" }}>
              Brands </Link> /
            <Typography sx={{ color: "#8E020F", fontWeight: "600", paddingLeft: "2px" }}>
              Add Brands
            </Typography>
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              margin: "20px 0 20px",
              width: "100%",
            }}
          >
            Add Brands
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", width: "98%" }}>
        <Box sx={{ width: "60%", padding: "0 32px" }}>
          {/* <ImageUploadSection setuploadedImage={setuploadedImage} /> */}
          {/* <Boximageuploader largeimagedata={''} imageDataValue1={''} edit={undefined} keyvisuallength={undefined} /> */}
          <Imageuploadbrand largeimagedata={null} imageDataValue1={null} keyvisuallength={0} edit={undefined} setTopPanel={setTopPanel}
            setKeyVisual={setKeyVisual} />
        </Box>
        <Box sx={{ width: "40%" }}>
          <FormBrand
            brandName={brandName}
            setBrandName={setBrandName}
            availableLocation={availableLocation}
            setAvailableLocation={setAvailableLocation}
            packDetails={packDetails}
            setPackDetails={setPackDetails} />
        </Box>
      </Box>
      <Box sx={{ padding: "30px 32px" }}>
        <BrandTable branddetails1={branddetails1 ? branddetails1 : []} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          background: "#fff",
          fontSize: "14px",
        }}
      >
        <Link href="/brands" underline="none" sx={{ color: "#C8172F" }}>
          {"← Back"}
        </Link>
        <Button
          onClick={handleAddBrand}
          variant="contained"
          color="primary"
          disabled={!isFormValid}
          sx={{
            background: "#C8172F",
            color: "#fff",
            width: "200px",
            padding: "10px 0",
            textTransform: "capitalize",
            fontSize: "14px",
          }}
        >
          Submit
        </Button>
      </Box>
    </div>
  );
}
